import { useRef } from 'react'

/**
 * 生成一个不会变化的事件处理函数，使用该hook生成的函数为事件函数不会产生重复注册的问题。
 * 传入参数为函数，可以使用useCallback生成的函数。
 * 作为参数的函数，如果里面调用了其它函数，请注意作用域、闭包问题；
 * 建议将被调用函数也用该Hook包装，这样两个函数就不在同一个闭包但可以相互调用。
 * @param { * } fn 回调处理函数
 */
export const useEventHandler = (fn: Function) => {
	const ref = useRef({
		fn,
		instFn: (...args: any[]) => ref.current.fn(...args)
	})
	ref.current.fn = fn
	return ref.current.instFn
}